import type { QuickAddMultiOptionFormProps } from './types'
import { Form } from '../../../components/Form'
import { Icon } from '../../../components/Icon'
import { flattenVariantOptions } from './utils/flattenVariantOptions'
import { OptionSelect } from './OptionSelect'
import { useTranslation } from 'react-i18next'

export const QuickAddMultiOptionForm: React.FC<
  QuickAddMultiOptionFormProps
> = ({
  flattenedVariants,
  linkedBottoms,
  onSubmit,
  isSubmitting,
  options,
  selectedInStock,
  selectedLinkedBottoms,
  selectedLinkedBottomsOptions,
  selectedOptions,
  status,
}) => {
  const isSuccess = status === 'success'
  const { t } = useTranslation()

  return (
    <form>
      <div className="flex gap-2">
        {options.map((option, index) => (
          <OptionSelect
            key={option.name}
            name={`options.${index}`}
            option={option}
            index={index}
            selectedOptions={selectedOptions}
            flattenedVariants={flattenedVariants}
          />
        ))}
      </div>
      {linkedBottoms.length > 0 && (
        <div className="mt-2 w-full">
          {selectedLinkedBottoms && (
            <div className="flex gap-2">
              {selectedLinkedBottoms.options.map((option, index) => {
                return (
                  <OptionSelect
                    key={option.name}
                    option={option}
                    index={index}
                    name={`linkedBottoms.options.${index}`}
                    selectedOptions={selectedLinkedBottomsOptions}
                    flattenedVariants={flattenVariantOptions(
                      selectedLinkedBottoms.variants,
                    )}
                  />
                )
              })}
            </div>
          )}
        </div>
      )}
      <Form.Submit
        size="lg"
        className="w-full mt-4"
        disabled={!selectedInStock || isSubmitting}
        onClick={onSubmit}
      >
        {isSuccess ? (
          <Icon.CheckCircle width={18} height={18} className="max-w-full" />
        ) : (
          <>
            {selectedInStock
              ? t('product.add_to_bag')
              : t('product.out_of_stock')}
          </>
        )}
      </Form.Submit>
    </form>
  )
}
